<template>
  <form class="login-form" v-on:submit.prevent="login">

    <div class="form-group">

      <input id="username"
             type="text"
             class="username form-control"
             v-bind:class="{ 'is-invalid': loginErrorText }"
             :placeholder="enterUsernameText"
             v-model.trim="username"
             autofocus
             required>

      <div class="invalid-feedback" v-if="loginErrorText">
        <ul class="error-list list-unstyled">
          <li v-for="error in loginErrorText">
            {{ error }}
          </li>
        </ul>
      </div>
    </div>

    <button class="join btn btn-primary btn-block"
            type="submit"
            :disabled="connecting">
      {{ loginButtonText }}
    </button>

  </form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'LoginForm',

  data: function () {
    return {
      username: '',
      regex: /^[A-Za-z]\w{2,16}$/
    }
  },

  watch: {
    username: function (val) {
      this.username = val

      if (this.loginErrorText) {
        this.clearLoginErrorText()
      }
    }
  },

  computed: {
    ...mapGetters([
      'usernameErrorText',
      'enterUsernameText',
      'loginButtonText',
      'loginErrorText',
      'connecting'
    ])
  },

  methods: {
    ...mapActions([
      'connect'
    ]),

    ...mapMutations([
      'clearLoginErrorText',
      'setLoginErrorText'
    ]),

    login () {
      const valid = this.regex.test(this.username)
      if (!valid) {
        this.setLoginErrorText({ error: this.usernameErrorText })
        return
      }

      this.connect({ user: this.username })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.form-control {
  border-color: $border-color;
  outline: none;

  &:focus {
    border-color: $border-color;
    box-shadow: none;
    outline: none;
  }
}

.btn {
  &:focus, &active {
    box-shadow: none;
    outline: none !important;
  }
}

.login-form {
  padding: 10%;
}

.error-list li:not(:last-child) {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginForm.vue